import Cookie from 'universal-cookie'
import { getAuthInformation } from '@dafiti/authentication-sdk'
import { ensureUUIDCookie } from '@dafiti/feature-flag-sdk'
import type { InstrumentationProvider } from '../core/Instrumentation'

/**
 * Sets the user in the instrumentation provider using available user identifiers.
 * Only executes on client-side (when window is available).
 *
 * @param instrumentation - The instrumentation provider to set the user on
 * @returns void
 */
export function setUserFromAvailableIdentifiers(
  instrumentation: InstrumentationProvider,
): void {
  // Only execute on client-side
  if (typeof window === 'undefined') return

  const uuid = ensureUUIDCookie()

  if (uuid) {
    instrumentation.setUser(uuid, getUserInfo())
  }
}

function getUserInfo() {
  const cookies = new Cookie(document.cookie)
  const accessToken = cookies.get('access_token')

  return getAuthInformation(accessToken)
}
